import { render, staticRenderFns } from "./BeneficiarioDetalle.vue?vue&type=template&id=17da17d1&"
import script from "./BeneficiarioDetalle.vue?vue&type=script&lang=js&"
export * from "./BeneficiarioDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports